import React from 'react';
import PropTypes from 'prop-types';
import head from 'lodash/head';
import InputFilter from 'Common/Components/Contextualization/InputFilter';
import ColorImage from 'Common/Components/ColorImage';
import getUserInitials from './functions';
import {
  OptionRow, OptionInfo, OptionName, OptionEmail, RolePill
} from './styled';

const UserSelector = ({ data, onSelect, placeholder = '', id = undefined }) => {
  const searchableData = data.map((user) => ({ ...user, name: user.username }));

  const renderItem = (user) => {
    const role = head(user.roles);

    return (
      <OptionRow>
        <ColorImage title={ user.username } role={ role } initials={ getUserInitials(user.username) } size={ 32 } />
        <OptionInfo>
          <OptionName children={ user.username } />
          { user.email && <OptionEmail children={ user.email } /> }
        </OptionInfo>
        <RolePill children={ role } />
      </OptionRow>
    );
  };

  return (
    <InputFilter
      getObjects={ () => {} }
      data={ searchableData }
      placeholder={ placeholder }
      onSelect={ ({ username }) => onSelect(username) }
      onChange={ () => {} }
      cleanOnSelect
      required={ false }
      id={ id }
      renderItem={ renderItem }
    />
  );
};

UserSelector.propTypes = {
  data: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  id: PropTypes.string
};

export default UserSelector;
